var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartGraph1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.83;}.cls-2{fill:#dfdfdf;}.cls-3{fill:#61cad6;}.cls-4{fill:#6bd5e1;}.cls-5{fill:#e49d75;}.cls-6{fill:#ffc48e;}.cls-7{fill:#ffd98e;}.cls-8{fill:#ffe3ad;}.cls-9{fill:#ff8364;}.cls-10{fill:#949494;}.cls-11{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.13,447.41a84.93,84.93,0,1,1,84.92,84.93A84.92,84.92,0,0,1,513.13,447.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.44,1055.12l-24.72,14.57v3.59H346v-18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.18,1056.12h23.7v16.31h-23.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.43,797.1l88.13,26.17-15,50.58-88.13-26.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.18,719.87,321.3,1056.71l26.76.22L402.9,836.5l-1.31-109.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M476,719.21c-.43,9.58-1.53,338.19-1.53,338.19l-26.1.19L367.21,727.48S476.45,709.64,476,719.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M313.16,626.73c-5.42,9.14-18.4,78.1-18.28,94.23-4.18,14.45-.79,57.9-.68,63.66s-1,27.31.23,32.61c-3.28,8.36,13.31,25.74,18.39,26.19s11.06-8.46,11.06-12.76c0-10.94-7.13-20.19-7-24.71.68-22.57,10.5-80.13,11.74-84s5.42-11.4,8.92-14.45,5.19-70.19,5.19-70.19S316.05,621.86,313.16,626.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M384.2,510.42c0,2.84,1.74,28.9-1.58,34.75s32.78,3.87,32.78-.56-1.19-25,1.73-32.45S384.2,507.57,384.2,510.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M507.05,587.61l5.28,3.85s45.36-87.82,45.91-91-3-11-2.46-14.73,18.79-21.82,24.51-22.1,6.17,2.55,4.77,5.34-12.35,13.91-12.35,13.91,7.58-2.09,10.23,0,12.7,15.49,8.93,21.35-11,8.79-12.42,12.28S534.93,641.2,529.64,643.59c-8.93,4-37.81-10-42.14-16.88S507.05,587.61,507.05,587.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M366.88,549.77c29.65,10.71,10.35,89.52.94,95-7.45,4.32-61.9-12.84-63.76-21.07C301.3,611.51,341.11,540.47,366.88,549.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M404.17,535.55c76.13-.25,83.53,173.37,70.75,185.25-23,21.41-133.65,11.82-138.47.46C328.54,702.64,332.26,535.78,404.17,535.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M415.27,566.27c13.13-28.65,90.07-2.86,94.71,7,3.69,7.79-18,60.62-26.31,61.79C471.32,636.76,403.85,591.17,415.27,566.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M371,473.36c0-24.88,15.39-45.05,34.38-45.05s34.38,20.17,34.38,45.05-15.39,45.06-34.38,45.06S371,498.24,371,473.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M359.68,467.56c-1.26-18.8,9.61-36.27,13.48-47.25,3.34-10.56,10-18.4,18.6-18.81s11,1.77,16.73,1.56,15.68-6.69,22.16-6.69S441,401,445,403.9s12.26,8.36,12.23,13.17c-.17,28.92-26.6,26.18-34.29,34.49-5.22,4.39-5.54,14.64-8.15,16.31s-8.26.68-8.36,8.89c-.06,4.83,1.25,8.78,4.7,9.09s4.67,1.57,4.6,4.08C415,514.15,397.9,518.7,390.93,518c-9.77-.92-12.54-12.85-14.95-16.93C366.74,490.76,360.46,479.38,359.68,467.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M593.93,451.1l12.73-54.17,12.74-54.18L644,355.63l24.57,12.88-37.3,41.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M724.7,367.17H968.88V517.33H724.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M739.43,379.23H761.1v126H739.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M771.6,397.5h21.67V505.27H771.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M803.78,425.22h21.67v80H803.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M836,462.83h21.66v42.44H836Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M868.13,426.4H889.8v78.87H868.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M900.31,398.91H922V505.27H900.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M932.49,379.23h21.66v126H932.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M609.3,662.28l45.9-45.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M681.08,640.78l49.27-49.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M756,615.27l10.71-10.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M808.57,645.79l64-64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M655.35,615.61l24.59,24.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M730.42,592l24.38,24.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M767.34,604l41.27,41.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M874.2,580.21l15.92,15.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.73,616.42a2.75,2.75,0,1,1,2.75,2.75A2.75,2.75,0,0,1,652.73,616.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.89,639.83a2.75,2.75,0,1,1,2.75,2.75A2.75,2.75,0,0,1,677.89,639.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.39,592.84a2.75,2.75,0,1,1,2.74,2.75A2.75,2.75,0,0,1,727.39,592.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.61,615.75a2.75,2.75,0,1,1,2.75,2.75A2.75,2.75,0,0,1,752.61,615.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.53,604.19a2.75,2.75,0,1,1,2.75,2.75A2.75,2.75,0,0,1,764.53,604.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.05,644.61a2.75,2.75,0,1,1,2.75,2.75A2.75,2.75,0,0,1,806.05,644.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.41,581a2.75,2.75,0,1,1,2.75,2.75A2.75,2.75,0,0,1,871.41,581Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartGraph1);
export default __webpack_public_path__ + "static/media/chart_graph_1.e4415fff151dc3f34f7a1bf763e84088.svg";
export { ForwardRef as ReactComponent };